import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ReportsPage.css';

const REPORT_TILES = [
  {
    path: '/reports/trial-balance',
    icon: 'fas fa-balance-scale',
    title: 'Trial Balance',
    desc: 'Opening + movements + closing per period. Detail or totals view. Excel export.',
    color: 'blue',
  },
  {
    path: '/reports/ytd',
    icon: 'fas fa-calendar-alt',
    title: 'Year-to-Date (YTD)',
    desc: 'Account movements over a date range. Ledger-card detail or account totals. Excel export.',
    color: 'teal',
  },
  {
    path: '/reports/pnl',
    icon: 'fas fa-chart-pie',
    title: 'Revenues & Expenses (P&L)',
    desc: 'Income vs expenditure for a period or full fiscal year. Net income summary.',
    color: 'green',
  },
  {
    path: '/reports/balance-sheet',
    icon: 'fas fa-university',
    title: 'Balance Sheet',
    desc: 'Assets vs liabilities as of a period end. Includes net income reconciliation.',
    color: 'indigo',
  },
  {
    path: '/reports/outstanding-vouchers',
    icon: 'fas fa-clock',
    title: 'Outstanding Vouchers',
    desc: 'All draft (not-yet-posted) vouchers. Useful for daily closing audit.',
    color: 'amber',
  },
  {
    path: '/reports/audit-log',
    icon: 'fas fa-clipboard-list',
    title: 'User Actions Log',
    desc: 'System-wide audit trail: logins, voucher creates/posts/reversals, account changes.',
    color: 'slate',
  },
];

const ReportsPage = () => {
  const navigate = useNavigate();
  return (
    <div className="reports-landing">
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title">Reports</h1>
          <p className="page-subtitle">Financial reports and accounting statements</p>
        </div>
      </div>
      <div className="reports-grid">
        {REPORT_TILES.map((tile) => (
          <button
            key={tile.path}
            className={`report-tile report-tile--${tile.color}`}
            onClick={() => navigate(tile.path)}
          >
            <div className="report-tile__icon">
              <i className={tile.icon}></i>
            </div>
            <div className="report-tile__body">
              <h3 className="report-tile__title">{tile.title}</h3>
              <p className="report-tile__desc">{tile.desc}</p>
            </div>
            <i className="fas fa-chevron-right report-tile__arrow"></i>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReportsPage;
